import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './Trainings.css';
import Courses from '../Courses/Courses'

const Trainings = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top of the page
    }, []);

    // Training programs list with background images
    const trainingPrograms = useMemo(() => [
        {
            name: "Python Training Program",
            description: "Step into the world of programming with our industry-aligned Python Training Program. Whether you're a beginner or looking to enhance your skills in data science or web development, this course offers Python fundamentals, data manipulation, and web frameworks like Django and Flask.",
            batch: "February 5, 2025",
            timings: "7:00 PM - 9:00 PM IST",
            location: "Online | In-person at HAMO Tech, Hyderabad",
            highlights: [
                "Hands-on projects: Develop banking and inventory management applications.",
                "Learn API integration and database management.",
                "Industry-relevant curriculum tailored for enterprise applications.",
            ],
            backgroundImage: "https://hamotech.sg/static/media/pyton_img.60731591762b6b141fad.png",
            filePath: "/coursepdf/python-Syllabus.pdf"
        },
        {
            name: "MERN Stack Training Program",
            description: "Master full-stack development with our comprehensive MERN Stack Training Program. This course covers everything from creating dynamic front-end interfaces with React to building scalable back-end systems using Node.js. You'll also gain in-depth knowledge of MongoDB for database management and Express.js for middleware applications.",
            batch: "February 12, 2025",
            timings: "6:00 PM - 8:00 PM IST",
            location: "Online | In-person at HAMO Tech, Hyderabad",
            highlights: [
                "Work on real-world projects such as e-commerce platforms.",
                "Master RESTful APIs and GraphQL.",
                "Get hands-on experience with deployment using cloud platforms.",
            ],
            backgroundImage: "https://hamotech.sg/static/media/REACT_IMAGES.7b0997369a2a1b384aa1.PNG",
            filePath: "/coursepdf/MEAN_MERN STACK.pdf"
        },
        {
            name: "Java Full-Stack Development Program",
            description: "Become a Java expert with our advanced Java Full-Stack Development Program. Begin with Java basics, explore Object-Oriented Programming, and gain proficiency in frameworks like Spring Boot, Hibernate, and Microservices.",
            batch: "February 20, 2025",
            timings: "6:30 PM - 8:30 PM IST",
            location: "Online | In-person at HAMO Tech, Hyderabad",
            highlights: [
                "Hands-on projects: Develop banking and inventory management applications.",
                "Learn API integration and database management.",
                "Industry-relevant curriculum tailored for enterprise applications.",
            ],
            backgroundImage: "https://hamotech.sg/static/media/java_fullstack.9ac5285cbe5b01de31a2.png",
            filePath: "/coursepdf/JavaFullStack.pdf"
        },
        {
            name: "Software Testing Training Program",
            description: "Master quality assurance with our expert-led Software Testing Training Program. This course covers manual testing fundamentals, advanced automation with Selenium, and performance testing methodologies, along with insights into CI/CD pipelines.",
            batch: "February 18, 2025",
            timings: "5:00 PM - 7:00 PM IST",
            location: "Online | In-person at HAMO Tech, Hyderabad",
            highlights: [
                "Gain practical experience with tools like TestNG, JUnit, and Selenium WebDriver.",
                "Introduction to mobile app testing and API testing.",
                "Real-time test case development and bug reporting.",
            ],
            backgroundImage: "https://hamotech.sg/static/media/software_testing.86d49a624f51948eaf98.png",
            filePath: "/coursepdf/Software Testing & Automation.pdf"
        },
        {
            name: "DevOps Training Program",
            description: "Accelerate your career with our hands-on DevOps Training Program. Learn DevOps methodologies, version control, CI/CD tools like Jenkins, containerization with Docker, and orchestration with Kubernetes.",
            batch: "March 1, 2025",
            timings: "8:00 AM - 10:00 AM IST",
            location: "Online | In-person at HAMO Tech, Hyderabad",
            highlights: [
                "Hands-on training with tools like Jenkins, Ansible, and Terraform.",
                "Real-world projects: Build CI/CD pipelines and deploy Kubernetes clusters.",
                "Prepare for certifications such as AWS DevOps Engineer and Certified Kubernetes Administrator (CKA).",
            ],
            backgroundImage: "https://hamotech.sg/static/media/devops.0a683882dd511588d952.png",
            filePath: "/coursepdf/DeVops-Syllabus.pdf"
        },
    ], []);


    // Function to handle file download
    const handleDownload = (filePath) => {
        const link = document.createElement("a");
        link.href = filePath;
        link.download = filePath.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <>
            <div className='Trainings_component'>
                <div className='container-fluid'>
                    {/* Training Page Header */}
                    <div className='Trainings_component_content'>
                        <h2>Transform Your Career with Our Expert-Led Training Programs</h2>
                        <p>Welcome to a learning experience at <b>HAMO Tech</b> that transforms careers! Our training programs are designed to empower individuals with the skills and knowledge needed to succeed in today's rapidly evolving tech industry. With hands-on sessions, real-world projects, and guidance from industry experts, you'll gain the confidence to tackle challenges and stand out in your career.</p>
                        <p>Check out our upcoming training sessions below and take the first step toward unlocking your full potential with HAMO Tech!</p>
                        <p>Skill up with training programs at HAMO Tech that keep you ahead in the ever-changing tech landscape. Whether you're looking to build foundational knowledge or master advanced concepts, our courses are tailored to cater to all levels of expertise. Learn through interactive sessions, live projects, and mentorship from industry leaders.</p>
                        <p>Don't miss our upcoming sessions – designed to help you grow, innovate, and succeed with HAMO Tech!</p>
                        <p>At HAMO Tech, learning meets innovation. Our training programs are created to provide a seamless blend of theoretical knowledge and practical experience. From interactive workshops to real-world projects, you'll gain insights that are both valuable and applicable.</p>
                        <p>Explore the schedule for our upcoming sessions below and take your career to new heights with HAMO Tech!</p>
                        <p>Your journey to success starts here at HAMO Tech! Our training programs are built around a student-first philosophy, offering tailored learning paths, practical projects, and mentorship from industry professionals. Whether you're new to the field or looking to specialize, we have something for everyone.</p>
                        <p>Discover our upcoming sessions below and enroll to turn your ambitions into achievements with HAMO Tech!</p>
                    </div>

                    {/* Training List Section */}
                    {/* <div className="training-list">
                        <h3>Available Training Programs</h3>
                        <ul>
                            {trainingPrograms.map((program, index) => (
                                <li key={index}>{program.name} - {program.batch}</li>
                            ))}
                        </ul>
                    </div> */}

                    {/* Training Cards Section */}
                    <div className='Trainings_component_cards'>
                        {trainingPrograms.map((program, index) => (
                            <div key={index} className='card training-card' >
                                <div className='row'>
                                    <div className='col-md-4 Trainings_component_cards_bg' style={{
                                        backgroundImage: `url(${program.backgroundImage})`,
                                    }}>

                                    </div>
                                    <div className='col-md-8 m-auto Trainings_component_cards_content'>
                                        <h3>{program.name}</h3>
                                        <p>{program.description}</p>
                                        <ul style={{ listStyleType: "none", paddingLeft: "0px" }}>
                                            {/* <li>📅 Next Batch: {program.batch}</li>
                                            <li>⏰ Timings: {program.timings}</li> */}
                                            <li>📍 Location: {program.location}</li>
                                        </ul>
                                        <h6>Key Highlights:</h6>
                                        <ul style={{ listStyleType: "none", paddingLeft: "0px" }}>
                                            {program.highlights.map((highlight, i) => (
                                                <li key={i}>
                                                    <i className="ri-arrow-right-double-fill pr-2"></i>
                                                    {highlight}
                                                </li>
                                            ))}
                                        </ul>
                                        <p>📞 For more details, contact us now!
                                            <span>
                                                <Link to="/contact-us">
                                                    <button className='btn btn-danger ml-2'>Contact</button>
                                                </Link>
                                            </span>

                                            <span>
                                                <Link to="#">
                                                    {program.filePath && (
                                                        <button className='btn download_syllabus_btn ml-2'
                                                            onClick={() => handleDownload(program.filePath)}>
                                                            Download Syllabus
                                                        </button>
                                                    )}
                                                </Link>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>




                    <div className='mt-5 mb-5'>
                        <div className='pt-5 pb-3'>
                            <h3 style={{ color: "#e65753" }}>Elevate Your Skills with Industry-Leading Courses!</h3>
                            <p style={{ color: "#8a8a8a" }}>At <b>HAMO Tech</b>, we are committed to providing cutting-edge training programs that empower learners to master in-demand technologies. Whether you're a beginner looking to start your tech journey or an experienced professional aiming to upskill, our courses are designed to help you succeed in today's competitive job market.</p>
                            <p style={{ color: "#8a8a8a" }}>Explore our expert-led courses, featuring hands-on training, real-world projects, and certification programs that open doors to exciting career opportunities.</p>
                        </div>
                        <Courses />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Trainings;
